import { assertNever } from "@@/shared/assert-never";
import { sumPrices } from "@@/shared/prices/sum-prices";
import type { Settlement } from "../settlement";

const getOriginPrice = (originEvent: Settlement["originEvent"]) => {
    switch (originEvent.type) {
        case "CREATED":
            return originEvent.order.totalPrice;
        case "ORDER_CHANGED":
            return sumPrices(originEvent.changes.map(change => change.price));
        default:
            assertNever(originEvent, "Unknown origin event type");
    }
};

export { getOriginPrice };
